import { UtilityText } from 'component/text';
import { componentWithVariants, demoFile, variant } from 'system/demo';
import { WithFeatures } from 'util/testutil';

import { ParentDatastoreProvider, useParentDatastore } from '../parentdatastore';

function ShowLanguage(): JSX.Element {
    const datastore = useParentDatastore();
    return <UtilityText testID='language' text={datastore.getLanguage()} />;
}

function ParentDatastoreDemo({ useProvider }: { useProvider: boolean }): JSX.Element {
    const content = <ShowLanguage />;
    return useProvider ? (
        <WithFeatures language='german'>
            <ParentDatastoreProvider>{content}</ParentDatastoreProvider>
        </WithFeatures>
    ) : (
        <WithFeatures language='english'>{content}</WithFeatures>
    );
}

demoFile('open-modules/zdf/component/parentdatastore');

componentWithVariants('ParentDatastoreProvider', ParentDatastoreDemo, {}, [
    variant('Without provider', { args: { useProvider: false } }),
    variant('With provider', { args: { useProvider: true } }),
]);
